import { Page } from "@hospital/components/layout";
import { observer } from "mobx-react";
import React, { useEffect, useMemo, useState } from 'react';

import { useApp, useCurrentRoute, useRouteBreadcrumb } from '@common/hooks';
import { IMacroModel, macroTypes } from '@common/models';
import { MacroTargetType, MacroType } from '@common/models/Enums/MacroType';
import { MacroStore } from '@hospital/stores';
import { useNavigate, useParams } from 'react-router';
import { CommunicationTemplateForm } from './CommunicationTemplateForm';
import { useMacros } from "@common/components/richTextBox/useMacros";
import { useHospitalApp } from "@hospital/hooks";

export const CommunicationTemplateContainer = observer(() => {
    const navigate = useNavigate();
    const { configuration } = useApp();
    const hospitalApp = useHospitalApp();
    const currentHospital = hospitalApp!.currentHospital;
    const currentRoute = useCurrentRoute();
    const isRootRoute = currentRoute!.pathname.toLowerCase().indexOf('/myprofile') === 0;
    const macroStore = useMacros();
    // Grab the current macroId from query parameters and fetch the Macro
    const [store] = useState(new MacroStore());
    let { macroId } = useParams();
    const parsedMacroId = useMemo(
        () => parseInt(macroId!),
        [macroId]
    );

    const isCommunicationTemplateRoute = currentRoute!.pathname.toLowerCase().includes('communicationtemplates');
    const currentMacroTargetType = isCommunicationTemplateRoute ? MacroTargetType.ExamVisit : MacroTargetType.Sms

    useEffect(() => {
        parsedMacroId !== 0 && store.getMacro(parsedMacroId, currentMacroTargetType)
    }, [currentMacroTargetType, parsedMacroId, store]);

    useEffect(() => {
        if (currentHospital)
            macroStore.load();
    }, [currentHospital, macroStore]);

    // Breadcrumb management
    const { setBreadCrumb } = useRouteBreadcrumb();
    useEffect(() => {
        if (store.macro) {
            setBreadCrumb(store.macro.name);
        }
        else {
            setBreadCrumb("New Hospital Communication Template");
        }
    }, [store.macro, setBreadCrumb]);

    // Scope MacroType options
    const macroTypeOptions = macroTypes.filter(r => r.value == MacroType.Provider);

    // Form Actions
    const onSubmit = (at: IMacroModel) => {
        at.macroTargetTypeId = currentMacroTargetType;
        store.upsertMacro(at);
    }

    const onCancel = () => {
        navigate(`../..`);
    }

    const onDelete = (macroId: number) => {
        store.deleteMacro(macroId).then(() => {
            navigate(`../..`);
        });
    }
    return (
        <>
            {
                !isRootRoute &&
                <Page>
                    <Page.PageTitle text={store.macro === undefined ? "New Hospital Communication Template" : store.macro.name}></Page.PageTitle>
                    <Page.Content>
                        {
                            (store.macro !== undefined || parsedMacroId === 0) &&
                            <CommunicationTemplateForm
                                macro={store.macro}
                                macroScope={MacroType.Provider}
                                onSubmit={onSubmit}
                                onCancel={onCancel}
                                onDelete={onDelete}
                                users={[{ label: `${configuration.fullName}`, value: configuration.userId }]}
                                macroTypes={macroTypeOptions}
                                selectedUserId={configuration.userId} />
                        }
                    </Page.Content>
                </Page>
            }
            {
                isRootRoute &&
                <>
                    <Page.PageTitle text={parsedMacroId === 0 ? "New Hospital Communication Template" : store.macro?.name}></Page.PageTitle>
                    <Page.Content>
                        {
                            (store.macro !== undefined || parsedMacroId === 0) &&
                            <CommunicationTemplateForm
                                macro={store.macro}
                                macroScope={MacroType.Provider}
                                onSubmit={onSubmit}
                                onCancel={onCancel}
                                onDelete={onDelete}
                                users={[{ label: `${configuration.fullName}`, value: configuration.userId }]}
                                macroTypes={macroTypeOptions}
                                selectedUserId={configuration.userId} />
                        }
                    </Page.Content>
                </>

            }
        </>
    );
})
